const updates = [
  {
    time: '2 小时前',
    type: '上新',
    title: '蜜桃视频本月独家推荐第三批内容已上线',
    desc: '新增 42 部精选视频，涵盖多类型热门专题，VIP会员可直接观看全部内容。',
  },
  {
    time: '5 小时前',
    type: '更新',
    title: '红桃视频编辑力荐专题内容完成本周更新',
    desc: '编辑团队新增 28 部高分作品，同步调整了推荐排序逻辑以提升发现效率。',
  },
  {
    time: '8 小时前',
    type: '公告',
    title: '香蕉视频VIP免费频道新增会员专属内容',
    desc: '原VIP会员专属频道的 156 部精选视频已全面免费开放，无需登录即可观看。',
  },
  {
    time: '12 小时前',
    type: '上新',
    title: '樱花视频新番速递频道本季新作上线',
    desc: '最新一季热门番剧资源已同步更新，包含多部高期待值作品的首播内容。',
  },
  {
    time: '1 天前',
    type: '更新',
    title: '全站热播排行榜算法优化升级完成',
    desc: '引入更精准的热度加权机制，综合观看完成率与互动活跃度等新维度进行排名计算。',
  },
  {
    time: '1 天前',
    type: '公告',
    title: '日皮视频平台服务器性能升级维护完成',
    desc: '全线CDN节点扩容，进一步提升播放加载速度与稳定性，优化高峰期并发体验。',
  },
  {
    time: '2 天前',
    type: '上新',
    title: '独家策划专题系列第三期正式发布',
    desc: '围绕"经典回顾"主题整合多频道优质内容，为观众带来精选观影旅程。',
  },
  {
    time: '3 天前',
    type: '更新',
    title: '移动客户端内测版本功能更新进展',
    desc: 'iOS与Android双端内测持续推进中，已完成核心播放功能与频道浏览模块开发。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            日皮视频平台内容更新、功能优化与运营公告实时速递
          </p>
        </div>
        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/50 hidden sm:block"></div>
          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-4 md:gap-6 pl-0 sm:pl-12">
                <div className="hidden sm:flex absolute left-0 top-1 w-[38px] h-[38px] flex-shrink-0 items-center justify-center rounded-full bg-background-200 border-2 border-background-300/60 z-10">
                  <div
                    className={`w-2.5 h-2.5 rounded-full ${
                      item.type === '上新'
                        ? 'bg-primary-500'
                        : item.type === '更新'
                        ? 'bg-accent-400'
                        : 'bg-secondary-400'
                    }`}
                  ></div>
                </div>
                <div className="flex-1 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60">
                  <div className="flex items-center gap-2 mb-2">
                    <span
                      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded whitespace-nowrap ${
                        item.type === '上新'
                          ? 'bg-primary-100/10 text-primary-400'
                          : item.type === '更新'
                          ? 'bg-accent-100/10 text-accent-300'
                          : 'bg-secondary-100/10 text-secondary-300'
                      }`}
                    >
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-600">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}